module.exports = __webpack_public_path__ + "static/images/user_photo_female.5a3d7a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/commons/style/images/user_photo_female.png
// module id = 3qHX
// module chunks = 51